import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=6a58dbdc&scoped=true"
import script from "./alipay.vue?vue&type=script&lang=js"
export * from "./alipay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58dbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a58dbdc')) {
      api.createRecord('6a58dbdc', component.options)
    } else {
      api.reload('6a58dbdc', component.options)
    }
    module.hot.accept("./alipay.vue?vue&type=template&id=6a58dbdc&scoped=true", function () {
      api.rerender('6a58dbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/alipay.vue"
export default component.exports